import { Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import "./ToggleStyle.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "reactjs-popup/dist/index.css";
import "./assets/Style/Loading.css";
import "./assets/Style/Tabel.css";
import "./assets/Style/ColorsCode.css";
import "react-confirm-alert/src/react-confirm-alert.css";

import Home from "./Pages/Home/Home";
import Panel from "./Pages/Panel/Panel";
import Login from "./Pages/Login/Login";
import User from "./Pages/User/User";
import UserAE from "./Pages/User/UserAE";
import UserIdentity from "./Pages/User/UserIdentity";
import UserIdentityCompetitor from "./Pages/User/UserIdentityCompetitor";
import UserExp from "./Pages/User/UserExp";
import Competitors from "./Pages/Competitors/Competitors";
import CompetitorsAE from "./Pages/Competitors/CompetitorsAE";
import CompetitorPrice from "./Pages/CompetitorPrice/CompetitorPrice";
import CompetitorPriceAE from "./Pages/CompetitorPrice/CompetitorPriceAE";
import CompetitorConnect from "./Pages/CompetitorPrice/CompetitorConnect";
import CompetitorCategory from "./Pages/CompetitorCategory/CompetitorCategory";
import CompetitorCategoryAE from "./Pages/CompetitorCategory/CompetitorCategoryAE";
import Store from "./Pages/Store/Store";
import StoreAE from "./Pages/Store/StoreAE";
import StoreIdentity from "./Pages/Store/StoreIdentity";
import StoreCompetitor from "./Pages/Store/StoreCompetitor";
import Company from "./Pages/Company/Company";
import CompanyAE from "./Pages/Company/CompanyAE";
import CompanyIdentity from "./Pages/Company/CompanyIdentity";
import ListPrice from "./Pages/ListPrice/ListPrice";
import ManegeSite from "./Pages/Site/ManegeSite";
import Product from "./Pages/Product/Product";
import ProductAE from "./Pages/Product/ProductAE";
import ProductAddColor from "./Pages/Product/ProductAddColor";
import Color from "./Pages/MasterData/Color/Color";
import ColorAE from "./Pages/MasterData/Color/ColorAE";
import Berand from "./Pages/MasterData/Berand/Berand";
import BerandAE from "./Pages/MasterData/Berand/BerandAE";
import Country from "./Pages/MasterData/Country/Country";
import CountryAE from "./Pages/MasterData/Country/CountryAE";
import Type from "./Pages/MasterData/Type/Type";
import TypeAE from "./Pages/MasterData/Type/TypeAE";
import Ram from "./Pages/MasterData/Ram/Ram";
import RamAE from "./Pages/MasterData/Ram/RamAE";
import Rom from "./Pages/MasterData/Rom/Rom";
import RomAE from "./Pages/MasterData/Rom/RomAE";
import Series from "./Pages/MasterData/Series/Series";
import SeriesAE from "./Pages/MasterData/Series/SeriesAE";
import Network from "./Pages/MasterData/Network/Network";
import NetworkAE from "./Pages/MasterData/Network/NetworkAE";
import CompanyProduct from "./Pages/CompanyManage/CompanyProduct";
import CompetitorProduct from "./Pages/Competitors/CompetitorProduct";
import CompanyStoreStock from "./Pages/CompanyManage/CompanyStoreStock";
import CompanyStoreAvrage from "./Pages/CompanyManage/CompanyStoreAvrage";
import Warehouse from "./Pages/Warehouse/Warehouse";
import WarehouseAE from "./Pages/Warehouse/WarehouseAE";
import SmsSetting from "./Pages/SmsSetting/SmsSetting";
import SmsSettingAE from "./Pages/SmsSetting/SmsSettingAE";
import Setting from "./Pages/Setting/Setting";
import SettingAE from "./Pages/Setting/SettingAE";
import PriceOffer from "./Pages/PriceOffer/PriceOffer";
import ShowMarket from "./Pages/ShowMarket/ShowMarket";
import PriceOfferAE from "./Pages/PriceOffer/PriceOfferAE";
import Prices from "./Pages/Prices/Prices";
import PricesAE from "./Pages/Prices/PricesAE";
import LoginSite from "./Pages/Site/LoginSite";
import CompetitorPricePackeageAE from "./Pages/CompetitorPrice/CompetitorPricePackeageAE";
import ShowMarketBy from "./Pages/ShowMarket/ShowMarketBy";
import CompanyStoreStockAll from "./Pages/CompanyManage/CompanyStoreStockAll";
import CompanyStoreStockByColor from "./Pages/CompanyManage/CompanyStoreStockByColor";
import SupplierType from "./Pages/Supplier/SupplierType";
import SupplierTypeAE from "./Pages/Supplier/SupplierTypeAE";
import Supplier from "./Pages/Supplier/Supplier";
import SupplierAE from "./Pages/Supplier/SupplierAE";
import SupplierWarehouse from "./Pages/Supplier/SupplierWarehouse";
import SupplierWarehouseAE from "./Pages/Supplier/SupplierWarehouseAE";
import SupplierBank from "./Pages/Supplier/SupplierBank";
import SupplierBankAE from "./Pages/Supplier/SupplierBankAE";
import WarehouseType from "./Pages/Supplier/WarehouseType";
import WarehouseTypeAE from "./Pages/Supplier/WarehouseTypeAE";
import WarehouseTypeIdentity from "./Pages/Supplier/WarehouseTypeIdentity";
import ShowSupplier from "./Pages/ShowSuppliers/Supplier";
import ShowSupplierBank from "./Pages/ShowSuppliers/SupplierBank";
import ShowSupplierWarehouse from "./Pages/ShowSuppliers/SupplierWarehouse";
import EmailSetting from "./Pages/EmailSetting/EmailSetting";
import Info from "./Pages/Info/Info";
import Footer from "./Pages/Footer/Footer";
import Register from "./Pages/Register/Register";
import SetCode from "./Pages/SetCode/SetCode";
import ForgetPass from "./Pages/ForgetPass/ForgetPass";
import ForgetPassAccept from "./Pages/ForgetPassAccept/ForgetPassAccept";
import ChangePass from "./Pages/ChangePass/ChangePass";
import ServiceOut from "./Pages/ServiceOut/ServiceOut";
import ServiceOutAE from "./Pages/ServiceOut/ServiceOutAE";
import SeriesEnd from "./Pages/MasterData/SeriesEnd/SeriesEnd";
import SeriesEndAE from "./Pages/MasterData/SeriesEnd/SeriesEndAE";
import CompetitorEntityUserId from "./Pages/Competitors/CompetitorEntityUserId";
import CompetitorPriceCopy from "./Pages/CompetitorPrice/CompetitorPriceCopy";

const NavPanel = ({ element }) => {
  let Token = localStorage.getItem("Token");
  return Token !== null ? <Navigate replace to="/Panel" /> : element;
};
const NavLogin = ({ element }) => {
  let Token = localStorage.getItem("Token");
  return Token !== null ? element : <Navigate replace to="/login" />;
};

function App() {
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="login" element={<NavPanel element={<Login />} />} />
        <Route path="Register" element={<Register/>} />
        <Route path="SetCode" element={<SetCode/>} />
        <Route path="ForgetPass" element={<ForgetPass/>} />
        <Route path="ForgetPassAccept" element={<ForgetPassAccept/>} />
        <Route
          path="/"
          element={<NavPanel element={<Navigate replace to="/login" />} />}
        />
        <Route
          path="*"
          element={<NavPanel element={<Navigate replace to="/login" />} />}
        />
        <Route
          path="Panel"
          element={<NavLogin element={<Navigate replace to="/Panel/Home" />} />}
        />

        <Route
          path="/Panel/Home"
          element={<NavLogin element={<Panel element={<Home />} />} />}
        />

        <Route
          path="/Panel/User"
          element={<NavLogin element={<Panel element={<User />} />} />}
        />
        <Route
          path="/Panel/ChangePass"
          element={<NavLogin element={<Panel element={<ChangePass />} />} />}
        />
        <Route
          path="/Panel/User/Add"
          element={<NavLogin element={<Panel element={<UserAE />} />} />}
        />
        <Route
          path="/Panel/User/Identity/:id"
          element={<NavLogin element={<Panel element={<UserIdentity />} />} />}
        />
        <Route
          path="/Panel/User/IdentityCom/:id"
          element={
            <NavLogin
              element={<Panel element={<UserIdentityCompetitor />} />}
            />
          }
        />
        <Route
          path="/Panel/User/Exp/:id"
          element={<NavLogin element={<Panel element={<UserExp />} />} />}
        />
        <Route
          path="/Panel/User/Edite/:id"
          element={<NavLogin element={<Panel element={<UserAE />} />} />}
        />

        <Route
          path="/Panel/PriceOffer"
          element={<NavLogin element={<Panel element={<PriceOffer />} />} />}
        />
        <Route
          path="/Panel/PriceOfferAE"
          element={<NavLogin element={<Panel element={<PriceOfferAE />} />} />}
        />
        <Route
          path="/Panel/Warehouses"
          element={<NavLogin element={<Panel element={<Warehouse />} />} />}
        />
        <Route
          path="/Panel/Warehouses/Add"
          element={<NavLogin element={<Panel element={<WarehouseAE />} />} />}
        />
        <Route
          path="/Panel/Warehouses/Edite/:id"
          element={<NavLogin element={<Panel element={<WarehouseAE />} />} />}
        />
        <Route
          path="/Panel/SmsSetting"
          element={<NavLogin element={<Panel element={<SmsSetting />} />} />}
        />
        <Route
          path="/Panel/SmsSetting/Add"
          element={<NavLogin element={<Panel element={<SmsSettingAE />} />} />}
        />
        <Route
          path="/Panel/SmsSetting/Edite/:id"
          element={<NavLogin element={<Panel element={<SmsSettingAE />} />} />}
        />
        <Route
          path="/Panel/ServiceOut"
          element={<NavLogin element={<Panel element={<ServiceOut />} />} />}
        />
        <Route
          path="/Panel/ServiceOut/Add"
          element={<NavLogin element={<Panel element={<ServiceOutAE />} />} />}
        />
        <Route
          path="/Panel/ServiceOut/Edite/:id"
          element={<NavLogin element={<Panel element={<ServiceOutAE />} />} />}
        />
        <Route
          path="/Panel/Settings"
          element={<NavLogin element={<Panel element={<Setting />} />} />}
        />
        <Route
          path="/Panel/Settings/Add"
          element={<NavLogin element={<Panel element={<SettingAE />} />} />}
        />
        <Route
          path="/Panel/Settings/Edite/:id"
          element={<NavLogin element={<Panel element={<SettingAE />} />} />}
        />
        <Route
          path="/Panel/EmailSetting"
          element={<NavLogin element={<Panel element={<EmailSetting />} />} />}
        />

        <Route
          path="/Panel/Info"
          element={<NavLogin element={<Panel element={<Info />} />} />}
        />

        <Route
          path="/Panel/Competitors/:id"
          element={<NavLogin element={<Panel element={<Competitors />} />} />}
        />
        <Route
          path="/Panel/Competitors/Add/:id"
          element={<NavLogin element={<Panel element={<CompetitorsAE />} />} />}
        />
        <Route
          path="/Panel/CompetitorPrice/AddCopy/:id/:extra"
          element={<NavLogin element={<Panel element={<CompetitorPriceCopy />} />} />}
        />
        <Route
          path="/Panel/Competitors/Edite/:id/:extra"
          element={<NavLogin element={<Panel element={<CompetitorsAE />} />} />}
        />
        <Route
          path="/Panel/Competitors/IdentityCom/:id/:extra"
          element={<NavLogin element={<Panel element={<CompetitorEntityUserId />} />} />}
        />

        <Route
          path="/Panel/Suppliers/Warehouse/:id"
          element={
            <NavLogin element={<Panel element={<SupplierWarehouse />} />} />
          }
        />
        <Route
          path="/Panel/Suppliers/Warehouse/Add/:id"
          element={
            <NavLogin element={<Panel element={<SupplierWarehouseAE />} />} />
          }
        />
        <Route
          path="/Panel/Suppliers/Warehouse/Edite/:id/:extra"
          element={
            <NavLogin element={<Panel element={<SupplierWarehouseAE />} />} />
          }
        />
        <Route
          path="/Panel/Suppliers/Bank/:id"
          element={<NavLogin element={<Panel element={<SupplierBank />} />} />}
        />
        <Route
          path="/Panel/Suppliers/Bank/Add/:id"
          element={
            <NavLogin element={<Panel element={<SupplierBankAE />} />} />
          }
        />
        <Route
          path="/Panel/Suppliers/Bank/Edite/:id/:extra"
          element={
            <NavLogin element={<Panel element={<SupplierBankAE />} />} />
          }
        />
        <Route
          path="/Panel/Suppliers/Warehouse/Type"
          element={<NavLogin element={<Panel element={<WarehouseType />} />} />}
        />
        <Route
          path="/Panel/Suppliers/Warehouse/Type/Add"
          element={
            <NavLogin element={<Panel element={<WarehouseTypeAE />} />} />
          }
        />
        <Route
          path="/Panel/Suppliers/Warehouse/Type/Edite/:id"
          element={
            <NavLogin element={<Panel element={<WarehouseTypeAE />} />} />
          }
        />
        <Route
          path="/Panel/Suppliers/Warehouse/Type/Identity/:id"
          element={
            <NavLogin element={<Panel element={<WarehouseTypeIdentity />} />} />
          }
        />

        <Route
          path="/Panel/CompanyManage/StockAll"
          element={
            <NavLogin element={<Panel element={<CompanyStoreStockAll />} />} />
          }
        />

        <Route
          path="/Panel/Companys/Store/:id"
          element={<NavLogin element={<Panel element={<Store />} />} />}
        />
        <Route
          path="/Panel/Companys/Store/Add/:id"
          element={<NavLogin element={<Panel element={<StoreAE />} />} />}
        />
        <Route
          path="/Panel/Companys/Store/Edite/:id/:extra"
          element={<NavLogin element={<Panel element={<StoreAE />} />} />}
        />
        <Route
          path="/Panel/Companys/Store/Identity/:id/:extra"
          element={<NavLogin element={<Panel element={<StoreIdentity />} />} />}
        />
        <Route
          path="/Panel/Companys/Store/Competitor/:id/:extra"
          element={
            <NavLogin element={<Panel element={<StoreCompetitor />} />} />
          }
        />

        <Route
          path="/Panel/CompanyProduct"
          element={
            <NavLogin element={<Panel element={<CompanyProduct />} />} />
          }
        />
        <Route
          path="/Panel/Competitors/Product/:id/:extra"
          element={
            <NavLogin element={<Panel element={<CompetitorProduct />} />} />
          }
        />
        <Route
          path="/Panel/CompanyStoreStocks"
          element={
            <NavLogin element={<Panel element={<CompanyStoreStock />} />} />
          }
        />
        <Route
          path="/Panel/CompanyStoreStockByColor"
          element={
            <NavLogin
              element={<Panel element={<CompanyStoreStockByColor />} />}
            />
          }
        />
        <Route
          path="/Panel/CompanyStoreAvrage"
          element={
            <NavLogin element={<Panel element={<CompanyStoreAvrage />} />} />
          }
        />

        <Route
          path="/Panel/CompetitorsCategory"
          element={
            <NavLogin element={<Panel element={<CompetitorCategory />} />} />
          }
        />
        <Route
          path="/Panel/CompetitorsCategory/Add"
          element={
            <NavLogin element={<Panel element={<CompetitorCategoryAE />} />} />
          }
        />
        <Route
          path="/Panel/CompetitorsCategory/Edite/:id"
          element={
            <NavLogin element={<Panel element={<CompetitorCategoryAE />} />} />
          }
        />
        <Route
          path="/Panel/Companys"
          element={<NavLogin element={<Panel element={<Company />} />} />}
        />
        <Route
          path="/Panel/Companys/Add"
          element={<NavLogin element={<Panel element={<CompanyAE />} />} />}
        />
        <Route
          path="/Panel/Companys/Edite/:id"
          element={<NavLogin element={<Panel element={<CompanyAE />} />} />}
        />
        <Route
          path="/Panel/Companys/Identity/:id"
          element={
            <NavLogin element={<Panel element={<CompanyIdentity />} />} />
          }
        />

        <Route
          path="/Panel/Products"
          element={<NavLogin element={<Panel element={<Product />} />} />}
        />
        <Route
          path="/Panel/Products/Add"
          element={<NavLogin element={<Panel element={<ProductAE />} />} />}
        />
        <Route
          path="/Panel/Products/AddColor"
          element={<NavLogin element={<Panel element={<ProductAddColor />} />} />}
        />
        <Route
          path="/Panel/Products/Edite/:id"
          element={<NavLogin element={<Panel element={<ProductAE />} />} />}
        />

        <Route
          path="/Panel/CompetitorPrice"
          element={
            <NavLogin element={<Panel element={<CompetitorPrice />} />} />
          }
        />
        <Route
          path="/Panel/CompetitorPrice/Add/:id"
          element={
            <NavLogin element={<Panel element={<CompetitorPriceAE />} />} />
          }
        />
        <Route
          path="/Panel/CompetitorPricePackeage/Add/:id"
          element={
            <NavLogin
              element={<Panel element={<CompetitorPricePackeageAE />} />}
            />
          }
        />
        <Route
          path="/Panel/CompetitorPrice/CompetitorConnect/:id"
          element={
            <NavLogin element={<Panel element={<CompetitorConnect />} />} />
          }
        />
        <Route
          path="/Panel/CompetitorPrice/Edite/:id/:extra"
          element={
            <NavLogin element={<Panel element={<CompetitorPriceAE />} />} />
          }
        />
        <Route
          path="/Panel/CompetitorPricePackeage/Edite/:id/:extra"
          element={
            <NavLogin
              element={<Panel element={<CompetitorPricePackeageAE />} />}
            />
          }
        />
        <Route
          path="/Panel/ListPrice"
          element={<NavLogin element={<Panel element={<ListPrice />} />} />}
        />
        <Route
          path="/Panel/Prices"
          element={<NavLogin element={<Panel element={<Prices />} />} />}
        />
        <Route
          path="/Panel/PricesAE/:extra"
          element={<NavLogin element={<Panel element={<PricesAE />} />} />}
        />
        <Route
          path="/Panel/Site"
          element={<NavLogin element={<Panel element={<ManegeSite />} />} />}
        />
        <Route
          path="/Panel/ShowMarket"
          element={<NavLogin element={<Panel element={<ShowMarket />} />} />}
        />
        <Route
          path="/Panel/ShowBuy"
          element={<NavLogin element={<Panel element={<ShowMarketBy />} />} />}
        />
        <Route
          path="/Panel/Site/Token/:StoreId"
          element={<NavLogin element={<Panel element={<LoginSite />} />} />}
        />
        <Route
          path="/Panel/Products/Color"
          element={<NavLogin element={<Panel element={<Color />} />} />}
        />
        <Route
          path="/Panel/Products/Color/Add"
          element={<NavLogin element={<Panel element={<ColorAE />} />} />}
        />
        <Route
          path="/Panel/Products/Color/Edite/:id"
          element={<NavLogin element={<Panel element={<ColorAE />} />} />}
        />

        <Route
          path="/Panel/Products/Berand"
          element={<NavLogin element={<Panel element={<Berand />} />} />}
        />
        <Route
          path="/Panel/Products/Berand/Add"
          element={<NavLogin element={<Panel element={<BerandAE />} />} />}
        />
        <Route
          path="/Panel/Products/Berand/Edite/:id"
          element={<NavLogin element={<Panel element={<BerandAE />} />} />}
        />

        <Route
          path="/Panel/Products/Type"
          element={<NavLogin element={<Panel element={<Type />} />} />}
        />
        <Route
          path="/Panel/Products/Type/Add"
          element={<NavLogin element={<Panel element={<TypeAE />} />} />}
        />
        <Route
          path="/Panel/Products/Type/Edite/:id"
          element={<NavLogin element={<Panel element={<TypeAE />} />} />}
        />

        <Route
          path="/Panel/Products/Rom"
          element={<NavLogin element={<Panel element={<Rom />} />} />}
        />
        <Route
          path="/Panel/Products/Rom/Add"
          element={<NavLogin element={<Panel element={<RomAE />} />} />}
        />
        <Route
          path="/Panel/Products/Rom/Edite/:id"
          element={<NavLogin element={<Panel element={<RomAE />} />} />}
        />

        <Route
          path="/Panel/Products/Series"
          element={<NavLogin element={<Panel element={<Series />} />} />}
        />
        <Route
          path="/Panel/Products/Series/Add"
          element={<NavLogin element={<Panel element={<SeriesAE />} />} />}
        />
        <Route
          path="/Panel/Products/Series/Edite/:id"
          element={<NavLogin element={<Panel element={<SeriesAE />} />} />}
        />

        <Route
          path="/Panel/Products/SeriesEnd"
          element={<NavLogin element={<Panel element={<SeriesEnd />} />} />}
        />
        <Route
          path="/Panel/Products/SeriesEnd/Add"
          element={<NavLogin element={<Panel element={<SeriesEndAE />} />} />}
        />
        <Route
          path="/Panel/Products/SeriesEnd/Edite/:id"
          element={<NavLogin element={<Panel element={<SeriesEndAE />} />} />}
        />

        <Route
          path="/Panel/Products/Network"
          element={<NavLogin element={<Panel element={<Network />} />} />}
        />
        <Route
          path="/Panel/Products/Network/Add"
          element={<NavLogin element={<Panel element={<NetworkAE />} />} />}
        />
        <Route
          path="/Panel/Products/Network/Edite/:id"
          element={<NavLogin element={<Panel element={<NetworkAE />} />} />}
        />

        <Route
          path="/Panel/Products/Ram"
          element={<NavLogin element={<Panel element={<Ram />} />} />}
        />
        <Route
          path="/Panel/Products/Ram/Add"
          element={<NavLogin element={<Panel element={<RamAE />} />} />}
        />
        <Route
          path="/Panel/Products/Ram/Edite/:id"
          element={<NavLogin element={<Panel element={<RamAE />} />} />}
        />

        <Route
          path="/Panel/Products/Country"
          element={<NavLogin element={<Panel element={<Country />} />} />}
        />
        <Route
          path="/Panel/Products/Country/Add"
          element={<NavLogin element={<Panel element={<CountryAE />} />} />}
        />
        <Route
          path="/Panel/Products/Country/Edite/:id"
          element={<NavLogin element={<Panel element={<CountryAE />} />} />}
        />

        <Route
          path="/Panel/Suppliers"
          element={<NavLogin element={<Panel element={<Supplier />} />} />}
        />
        <Route
          path="/Panel/Suppliers/Add"
          element={<NavLogin element={<Panel element={<SupplierAE />} />} />}
        />
        <Route
          path="/Panel/Suppliers/Edite/:id"
          element={<NavLogin element={<Panel element={<SupplierAE />} />} />}
        />

        <Route
          path="/Panel/SuppliersType"
          element={<NavLogin element={<Panel element={<SupplierType />} />} />}
        />
        <Route
          path="/Panel/SuppliersType/Add"
          element={
            <NavLogin element={<Panel element={<SupplierTypeAE />} />} />
          }
        />
        <Route
          path="/Panel/SuppliersType/Edite/:id"
          element={
            <NavLogin element={<Panel element={<SupplierTypeAE />} />} />
          }
        />
        <Route
          path="/Panel/ShowSupplier"
          element={<NavLogin element={<Panel element={<ShowSupplier />} />} />}
        />
        <Route
          path="/Panel/ShowSuppliers/Warehouse/:id"
          element={
            <NavLogin element={<Panel element={<ShowSupplierWarehouse />} />} />
          }
        />
        <Route
          path="/Panel/ShowSuppliers/Bank/:id"
          element={
            <NavLogin element={<Panel element={<ShowSupplierBank />} />} />
          }
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
